import classNames from 'classnames';
import React from 'react';
import { WaveformIcon, ListChecksIcon } from 'components/Icons';
import style from './TaskTypeIcon.scss';

interface TaskTypeIconProps {
  taskType: string;
  size?: number;
  className?: string;
}

export const TaskTypeIcon: React.FC<TaskTypeIconProps> = ({ taskType, size = 20, className }) => {
  // Default to wave icon for now as requested: SW-3057
  let icon: React.ReactNode = <WaveformIcon width={size} height={size} />;

  if (taskType === 'Assessment') {
    icon = <ListChecksIcon width={size} height={size} />;
  }

  return (
    <div
      className={classNames(
        style.iconContainer,
        {
          [style.messagingIcon]: taskType !== 'Assessment',
          [style.assessmentIcon]: taskType === 'Assessment'
        },
        className
      )}
    >
      {icon}
    </div>
  );
};
